import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
export function createLegacyTabDefinition(legacyClass, key, title, iconclass) {
    function LegacyTabAdapter(props) {
        const socket = useRef(null);
        const [tabInstance, setTabInstance] = useState(null);
        useEffect(() => {
            if (socket.current == null) {
                setTabInstance(null);
                return;
            }
            const instance = new legacyClass(props.ui);
            setTabInstance(instance);
            instance.element().css('overflow', 'visible');
            instance.element().appendTo(socket.current);
            return () => {
                instance?.element().detach();
                instance?.destroy();
            };
        }, [props.ui, /* socket.current, */ setTabInstance]);
        useEffect(() => {
            tabInstance?.device?.(props.device);
        }, [tabInstance, props.device]);
        useEffect(() => {
            tabInstance?.element().toggleClass('visible', props.active);
            if (props.active) {
                tabInstance?.activated();
            }
            else {
                tabInstance?.deactivated();
            }
        }, [props.active, tabInstance]);
        return _jsx("div", { className: "mobile-tabs-tab-socket-old-adapter", ref: socket });
    }
    return {
        key,
        title,
        iconclass,
        should_appear_depends_on: legacyClass.should_appear_depends_on,
        should_appear: legacyClass.should_appear,
        render: LegacyTabAdapter,
    };
}
